import { css as l, styled as r } from "styled-components";
import { SmartLink as t } from "../SmartLink/index.js";
import { Theme as o } from "../../styles/themes/index.js";
const e = l`
  text-decoration: none;
  display: flex;
  align-items: center;
  margin-right: 24px;
  width: 132px;
`, m = r(t)`
  ${e}

  color: rgb(${o.colors.Alpha});

  & [data-logoletter='true'] {
    fill: rgb(${o.colors.Alpha});
  }
`;
r(t)`
  ${e}
`;
export {
  m as HeaderLogoContainer
};
